const uuidv5 = require('uuid/v5');
const namespace = uuidv5(Math.random().toString(), '1546058f-5a25-4334-85ae-e68f2a44bbaf');

function plugin (Vue, options) {
    // Exit if the plugin has already been installed.
    if (plugin.installed) return

    const VideoAdSchedule = new Vue({

        data () {
            return {
                basePath: 'https://ad-ipd.sxp.smartclip.net/select',
                active: false,
                options: {
                    duration: 0,
                    streamurl: '',
                    type: 'vast3',
                    zone: null,
                    long_form: false,
                    referrer: 'https://www.rtl2.de',
                    fsk16: 1,
                },
                adDynamics: '&fwd_j4=2&fwd_j5=0&fwd_j5=1&fwd_j5=2&fwd_j5=3',
                consentString: ''
            }
        },

        computed: {

            armed() {
                return this.active && (this.options.zone !== null)
            },

            queryParams () {
                return {
                    type: this.options.type, //vast3
                    s: this.options.zone, // rtl2_rtl2/grip
                    sz: null, // pre, mid, post
                    opt: this.optOut ? 'out' : null,
                    fwd_cf: this.options.long_form ? 'long_form' : 'short_form',
                    ang_conlen: this.options.duration,
                    fwd_jgs : this.options.fsk16 ? 1: 0, // Jugendschutz
                    ang_ref: this.options.referrer,
                    ang_streamid: uuidv5(this.options.streamurl, namespace),
                    ang_plrw: '__player-width__',
                    ang_plrh: '__player-height__',
                    rnd: '__random-number__',
                    consent: this.consentString
                }
            },

            optOut () {
                return this.$helpers.getCookie('opt_out') == "1"
            },

            preroll () {
                return this.armed && this.$settings && this.$settings.ipAds ? this.$settings.ipAds.baseUrl + "?" +  this.adTagQueryString('pre') + this.adDynamics : null;
            },

            midroll () {

                if(this.options.duration < 480)
                    return null

                return this.armed && this.$settings && this.$settings.ipAds ? this.$settings.ipAds.baseUrl + "?" +  this.adTagQueryString('mid') + this.adDynamics : null;
            },

            postroll () {
                return this.armed && this.$settings && this.$settings.ipAds ? this.$settings.ipAds.baseUrl + "?" +  this.adTagQueryString('post') + this.adDynamics : null;
            },

            adSchedule () {

                let adSchedule = {}

                if(!this.armed) {
                    return adSchedule
                }

                if(this.preroll) {
                    adSchedule.preroll = {
                        offset: 'pre',
                        tag: this.preroll
                    }
                }

                if(this.midroll) {
                    adSchedule.midroll = {
                        offset: '50%',
                        tag: this.midroll
                    }
                }

                if(this.postroll) {
                    adSchedule.postroll = {
                        offset: 'post',
                        tag: this.postroll
                    }
                }

                return adSchedule
            }

        },

        methods: {

            init () {
                this.$l.log('videoAdSchedule plugin loaded')
                this.listenToConsentString()
                this.requestConsentString()

                // this.listenToAdDynamics()
                // this.requestAdDynamics()
            },

            setup ( params ) {
                for( var key in params ) {
                    this.options[key] = params[key]
                }

                if(this.$settings && this.$settings.ipAds && this.$settings.ipAds.zoneOverride) {
                    this.options.zone = this.$settings.ipAds.zoneOverride;
                }
            },

            activate() {
                this.active = true
                this.$homad.init()
            },

            deactivate() {
                this.active = false
            },

            set ( key, value ) {
                this.options[key] = value
            },

            getAdDynamics() {

                // instantly resolve if ads are disabled
                if(!this.$manager.get('ads')) {
                    this.$l.log("getAdDynamics - ads not enabled")
                    return Promise.resolve(true);
                }

                var vm = this;

                // Create a promise that rejects in <ms> milliseconds
                let timeout = new Promise((resolve, reject) => {
                    let id = setTimeout(() => {
                        clearTimeout(id);
                        resolve(false)
                    }, 3000)
                })

                let promise = new Promise(function(resolve, reject) {

                    window.addEventListener('message', function(event) {
                        if(event.data.action == 'sendAdDynamics') {
                            vm.$l.log("videoAdSchedule - receiving adDynamics", event.data)

                            if(event.data && event.data.hasOwnProperty('adDynamics')) {
                                vm.adDynamics = '&' + event.data.adDynamics
                                resolve(event.data.adDynamics);
                            }
                        }
                    });

                    vm.requestAdDynamics();


                });

                // Returns a race between our timeout and the passed in promise
                return Promise.race([
                    promise,
                    timeout
                ])

            },

            listenToAdDynamics() {
                // Listener für adDynamics der Parent Seite
                var vm = this;
                window.addEventListener('message', function(event) {
                    if(event.data.action == 'sendAdDynamics') {
                        vm.$l.log("videoAdSchedule - receiving adDynamics", event.data)

                        if(event.data && event.data.hasOwnProperty('adDynamics')) {
                            vm.adDynamics = '&' + event.data.adDynamics
                        }
                    }
                });
            },

            listenToConsentString() {
                // Listener für adDynamics der Parent Seite
                var vm = this;
                window.addEventListener('message', function(event) {
                    if(event.data.action == 'sendConsentString') {
                        vm.$l.log("videoAdSchedule - receiving consentString", event.data)

                        if(event.data && event.data.hasOwnProperty('consentString')) {
                            vm.consentString = event.data.consentString
                        }
                    }
                });
            },

            requestAdDynamics() {
                this.$l.log("videoAdSchedule - requesting adDynamics")
                window.parent.postMessage({action: 'reqAdDynamics'}, '*');
            },

            requestConsentString() {
                this.$l.log("videoAdSchedule - requesting consentString")
                window.parent.postMessage({action: 'reqConsentString'}, '*');
            },

            adTagQueryString( position ) {
                return this.$helpers.getQueryString( this.$helpers.assign(this.queryParams, {sz: position}) )
            },

            // loadHomad() {
            //     require('./homad/homad.js');
            // },

            getHomadConfig() {
                return this.$settings.homad
            },

            getAdTagForHomad(pos) {
                this.$l.log('homad - getting adTag',pos)

                switch(pos) {
                    case 'pre':
                        return this.preroll

                    case 'mid':
                        return this.midroll

                    case 'post':
                        return this.postroll

                    default:
                        return null
                }

            }

        }

    })

    VideoAdSchedule.init()

    // Extend `Vue.prototype` to include our global event bus.
    Object.defineProperty(Vue.prototype, '$videoAdSchedule', {
        get () {
            return VideoAdSchedule
        }
    })

    // window.getAdTag = function() {
    //     console.log('homad - getting preroll now from videadschedule')
    //     return VideoAdSchedule.preroll
    // }
}

// Check for `window.Vue`
if (typeof window !== 'undefined' && window.Vue) {
    // Install plugin automatically.
    window.Vue.use(plugin)
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/video-ad-schedule/index.js